/* eslint semi:0 */
import { getState, setState } from '../../../application/appStore'
import { TYPES as SLIDESHOW_ACTIONS } from '../../actions/slideshowActions'

const { START_SLIDE_CHANGE } = SLIDESHOW_ACTIONS

const SLIDESHOW_INITIAL_STATE = {
  changedSlidesCount: 0,
}

const stateKey = 'slideshow'

export default function slideshowReducer(state = SLIDESHOW_INITIAL_STATE, action) {
  switch (action.type) {
    case START_SLIDE_CHANGE:
      return setState(state, {
        changedSlidesCount: getState()[stateKey].changedSlidesCount + 1,
      })
    default:
  }
  return state
}

export { stateKey, slideshowReducer }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/slideshow/slideshowReducer.js